exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n/* CSS Document */\n/*メインコンテンツ系*/\n/*tooltip font*/\n/*ステータスカラー*/\n/* Sass Document */\n/* Filetype Web Font **********************************************************/\n.page-block {\n  padding-bottom: 68px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  background-color: #f0f0f0; }\n.scroll-y {\n  height: 100%;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box; }\n.layout-header {\n  background-color: white; }\n.loader-div-wrapper {\n  z-index: 12500;\n  position: absolute;\n  width: 100%; }\n.loader-div-wrapper .loaderdiv::after {\n    content: \"\\68DA\\5378\\3057\\30C7\\30FC\\30BF\\4F5C\\6210\\4E2D\\3067\\3059\"; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa7Inventory/wa7010/wa7010.component.scss
// module id = ../../../../../src/app/pages/wa7Inventory/wa7010/wa7010.component.scss
// module chunks = main